import { removeStorageItems } from './utils';

/**
 * @description Remove basket details on local storage when user logout
 * @returns {void}
 */
export const removeBasketDetailsOnLocalStorage = () =>
  removeStorageItems(['basketDetail', 'basketId', 'advanceDeadline']);
